import { EnvironmentModel } from './environment.model';

export const environment: EnvironmentModel = {
  qualtricsAlwaysOnFeedbackEnabled: true,
  featureAnnouncementRetentionMonths: 1,
  api: 'http://localhost:3000/',
  apimKey: '5f5a3d56d8d846eb9e52281f23edf1a7',
  appInsights: {
    instrumentationKey: '015e1a5d-853a-46b3-ab22-aa4019ea842e',
  },
  authApiUrl: 'https://scecp-auth.dnv.com/Auth',
  baseUrl: 'https://mycp.dev.dnv.com',
  certificateGraphqlHost:
    'https://testapi.dnv.com/ba-scecp-r2-certificateservice-dev',
  contactGraphqlHost: 'https://testapi.dnv.com/ba-scecp-r2-contactservice-dev',
  dnvLink: 'https://www.dnv.com/',
  documentsApi:
    'https://testapi.dnv.com/ba-scecpservices-r2-dev/v1/api/Documents',
  federatedLogoutUrl:
    'https://login.veracity.com/a68572e3-63ce-4bc1-acdc-b64943502e9d/oauth2/v2.0/logout?p=b2c_1a_signinwithadfsidp&post_logout_redirect_uri=https://www.veracity.com/auth/logout?redirectUri=',
  findingGraphqlHost: 'https://testapi.dnv.com/ba-scecp-r2-findingservice-dev',
  invoicesGraphqlHost: 'https://testapi.dnv.com/ba-scecp-financialservice-dev',
  auditGraphqlHost: 'https://testapi.dnv.com/ba-scecp-r2-auditservice-dev',
  production: false,
  scheduleGraphqlHost:
    'https://testapi.dnv.com/ba-scecp-r2-scheduleservice-dev',
  veracityUrl: 'https://id.veracity.com/',
  notificationGraphqlHost:
    'https://testapi.dnv.com/ba-scecp-notificationservice-dev',
  lmsUrl:
    'https://dnvtest.seertechsolutions.com/auth/oauth2/authorization/veracity',
  serviceNow: {
    moduleId:
      'https://customerservice-dev.dnv.com/#21e5e3d53baca2101cfcd2c5e4e45a63',
    scriptUrl: 'https://customerservice-dev.dnv.com/scripts/sn_csm_ec.js?v=5.6',
    sysIds: {
      catalogItem: '826bc6dd3b34a6501cfcd2c5e4e45af5',
      dnvInvoice: '4508b6b73b34aa101cfcd2c5e4e45a8f',
      dnvSchedule: 'd216bef33b34aa101cfcd2c5e4e45aaa',
      dnvCertificate: '47f372733b34aa101cfcd2c5e4e45a65',
      dnvCompanySettings: 'a8a43a5b2b3a6a501450ff65d891bf5f',
      dnvReschedule: '9a1f10fd3bfe22501cfcd2c5e4e45adc',
    },
  },
  cacheDuration: 3600000,
  trainingLink:
    'https://brandcentral.dnv.com/original/gallery/10651/files/original/b904d0a1-2559-45b5-88d1-53534b3e6ec5.pdf',
  translation: {
    baseUrl: 'https://mycp-assets-nonprod.dnv.com/primengdev',
    SAS: 'sp=r&st=2026-01-23T07:40:15Z&se=2027-01-23T15:55:15Z&spr=https&sv=2024-11-04&sr=c&sig=6s68%2F0oIa6Wtw04RNJfZZjnYNGR%2FcjrJLUj%2FwCSmuWc%3D',
  },
  maintenance: {
    blobUrl:
      'https://mycp-assets-nonprod.dnv.com/maintenance-config-primengdev/maintenance.json?sp=r&st=2026-06-10T13:32:29Z&se=2027-06-10T21:47:29Z&spr=https&sv=2026-02-06&sr=c&sig=SuPuKQvE%2Fy1H71k0sG6AWDTwYPYbyZdZE1Y8KCGpsjA%3D',
    functionsBaseUrl: 'https://testapi.dnv.com/ba-scecp-maintenance',
    signalRNegotiateUrl:
      'https://testapi.dnv.com/ba-scecp-maintenance/PRIMENGDEV',
    apimSubscriptionMaintenanceKey: '5f5a3d56d8d846eb9e52281f23edf1a7',
  },
};
